import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  // Safari before 16 has no requestSubmit (an iPad on iOS 15, say), so it submits the plain way.
  save() {
    if (this.element.requestSubmit) this.element.requestSubmit()
    else this.element.submit()
  }
}
